import UploadFileService from "../../Services/UploadFileService"

const currentFileName = 'standard_questions';

export async function UploadFile(currentData) {
    let isApiCallSuccessful = false;

    let fileName = currentFileName;
    let filePath = "/standard/" + fileName;

    //Get the last commitId for upload post request and tree url for repo get request.
    let commitId = "";
    let treeUrl = "";

    await UploadFileService.getStandardsFileRepoURL()
        .then(response => {
            if (response.status == 200) {
                isApiCallSuccessful = true;

                commitId = response.data.commitId;
                treeUrl = response.data._links.tree.href
            }
            else {
                isApiCallSuccessful = false;
            }
        })
        .catch((e) => {
            isApiCallSuccessful = false;

            commitId = "";
            treeUrl = "";
        });;

    //Get tree entries/list of files present in repo.
    let changeType = "";
    let files = []

    if (isApiCallSuccessful) {
        await UploadFileService.getUploadFileRepoEntities(treeUrl)
            .then(response => {
                if (response.status == 200) {
                    isApiCallSuccessful = true;

                    response.data.treeEntries.forEach(x => files.push(x.relativePath))

                    !files.includes(fileName) ? changeType = "add" : changeType = "edit";
                }
                else {
                    isApiCallSuccessful = false;
                }
            })
            .catch((e) => {
                isApiCallSuccessful = false;                    
            });;
    }

    //Post new file. 
    //JSON.stringify overload with , null, 4 formats the json file to match typical format. 4 being the spacing indentation.
    let base64currentDataContents = Buffer.from(JSON.stringify(currentData, null, 4)).toString("base64");

    let data = {
        refUpdates: [{
            name: "refs/heads/develop",
            oldObjectId: commitId
        }],
        commits: [{
            comment: changeType == "add" ? "Added new image file."
                : changeType == "edit" ? "Edited image file."
                    : "",
            changes: [{
                changeType: changeType,
                item: {
                    path: filePath
                },
                newContent: {
                    content: base64currentDataContents,
                    contentType: "base64encoded"
                }
            }]
        }]
    }

    if (isApiCallSuccessful) {
        await UploadFileService.postUploadFile(data)
            .then(response => {
                if (response.status != 201) {
                    isApiCallSuccessful = true;
                }
                else {
                    isApiCallSuccessful = false;
                }
            })
            .catch((e) => {
                isApiCallSuccessful = false;
            });;
    }
}